import { ChatType, MessageType } from 'utils/api/chats';
import { NoticeType } from 'utils/api/notice';
import { ChatListTypes } from 'utils/api';

const ANONYMOUS: ChatType = 'ANONYMOUS';
const REGULAR: ChatType = 'REGULAR';

export const chatTypes = {
  anonymous: ANONYMOUS,
  regular: REGULAR,
};

const ADVICE: NoticeType = 'ADVICE';
const ARTICLE: NoticeType = 'ARTICLE';
const INSTRUCTION: NoticeType = 'INSTRUCTION';
const INTERVENTION_PLAN: NoticeType = 'INTERVENTION_PLAN';
const MOVIE: NoticeType = 'MOVIE';

export const noticeTypes = {
  advice: ADVICE,
  article: ARTICLE,
  instruction: INSTRUCTION,
  intervention_plan: INTERVENTION_PLAN,
  movie: MOVIE,
};

const INTERVENER_RESPONSE: MessageType = 'INTERVENER_RESPONSE';
const REPORTER_MESSAGE: MessageType = 'REPORTER_MESSAGE';

export const messageTypes = {
  intervener_response: INTERVENER_RESPONSE,
  reporter_message: REPORTER_MESSAGE,
};

export type NotificationType = 'SUCCESS' | 'ERROR';

const SUCCESS: NotificationType = 'SUCCESS';
const ERROR: NotificationType = 'ERROR';

export const notificationTypes = {
  success: SUCCESS,
  error: ERROR,
};

const IMPORTANT: ChatListTypes = 'IMPORTANT';
const ASSIGNED: ChatListTypes = 'ASSIGNED';
const ALL: ChatListTypes = 'ALL';
const TAGGED: ChatListTypes = 'TAGGED';

export const chatlistTypes = {
  important: IMPORTANT,
  assigned: ASSIGNED,
  all: ALL,
  tagged: TAGGED,
};

/**
 * Page size used when a list view wants every record at once (no
 * pagination in the UI). Picked to be larger than any plausible record
 * count so the backend returns the whole set in one page.
 */
export const LOAD_ALL_PAGE_SIZE = 9999999;

export const MIN_SEARCH_QUERY_LENGTH = 3;

export const PICKER_PAGE_SIZE = 25;

export const PICKER_SEARCH_DEBOUNCE_MS = 300;

export const LIST_PAGE_SIZE = 50;
